import { render, staticRenderFns } from "./ButtonCheckBox.vue?vue&type=template&id=c8f4dab6&scoped=true&"
import script from "./ButtonCheckBox.vue?vue&type=script&lang=ts&"
export * from "./ButtonCheckBox.vue?vue&type=script&lang=ts&"
import style0 from "./ButtonCheckBox.vue?vue&type=style&index=0&id=c8f4dab6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8f4dab6",
  null
  
)

export default component.exports